<template>
    <div class="auctionList">
        <div class="listGood listView borderLRB">
            <ul>
                <li v-for="(item,index) in auctionLists" :key="index">
                    <div class="item fix">
                        <!--
                          原来这里是按硬编码下标取 pc_extra_info[12] / [13] / [6] / [14] / [9]。
                          但这个数组是"有值才下发"的变长数组：实测同一个机构下
                          有预展地点+拍卖地点的记录长度 15，没有这两项的记录长度只有 13，
                          index 10 之后整体错位——[12] 会从 time 变成 price，[13] 直接 undefined，
                          于是 undefined.text 抛 "Cannot read properties of undefined (reading 'text')"。
                          改为按 type 取值（与项目其它列表组件一致），取不到就退化成空字符串。
                        -->
                        <div class="dateBox fl">
                            <div class="date">
                                <div class="yearNum verdanF12">{{ timePart(item, 0) }}</div>
                                <div class="dateNum">{{ timePart(item, 1) }}</div>
                            </div>
                        </div>
                        <div class="infoBox fl">
                            <a class="auctionFont color333 fontLine" target="_blank" @click="handleRouter(item)">{{ item.name }}</a>
                            <div class="info fontSong12">
                                拍卖时间：
                                <span class="color333">{{ peText(item, 'time') }}</span>
                            </div>
                            <div class="info fontSong12">
                                拍卖地点：
                                <span class="color333">{{ peText(item, 'auction_place') }}</span>
                            </div>
                            <div class="info fontSong12">
                                拍卖专场：
                                <span class="color333">{{ peText(item, 'special_num') ? peText(item, 'special_num') : 0 }}个专场</span>
                            </div>
                        </div>
                        <div class="priceBox fr">
                            <div class="rate font14 fontLine yahei color999">
                                成交额：<span class="red verdanF14">{{ peText(item, 'price') }}</span>
                            </div>
                            <div class="rate font14 fontLine yahei color999">
                                成交率：<span class="red verdanF14">{{ peText(item, 'ratio') }}</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "auctionList",
    props: ['auctionLists'],
    data(){
        return{
            dataList:[{},{}],
        }
    },
    methods: {
        /**
         * 从 pc_extra_info 里按 type 取 text。
         * pc_extra_info 是变长数组（后端只下发有值的项），不能按下标取。
         * 本组件用到的 type：
         *   time          拍卖时间（如 "2026.07.16 - 08.06"）
         *   auction_place 拍卖地点
         *   special_num   专场数
         *   price         成交总额
         *   ratio         成交率
         */
        peText(item, type) {
            const list = (item && item.pc_extra_info) || []
            for (let i = 0; i < list.length; i++) {
                if (list[i] && list[i].type === type) return list[i].text || ''
            }
            return ''
        },
        // 拍卖时间按 '-' 拆成左右两段，分别显示在日期块的上下两行
        timePart(item, i) {
            const parts = String(this.peText(item, 'time')).split('-')
            return parts[i] || ''
        },
        handleRouter(item) {
            this.$router.push(`/meeting_detail/${item.sessionCode}`)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
.auctionList{
    ul{
        li{
            .date{
                width: 80px;
                height: 90px;
                .yearNum{
                    background: #ccc;
                    color: #fff;
                    height: 20px;
                    line-height: 18px;
                    text-align: center;
                    font-size: 13px;
                }
                .dateNum{
                    width: 80px;
                    height: 70px;
                    font: 20px/69px Verdana;
                    border-right: 1px solid #e6e6e6;
                    border-left: 1px solid #e6e6e6;
                    border-bottom: 1px solid #e6e6e6;
                    text-align: center;
                    color: #999;
                    font-weight: bold;
                    background: #fff;
                }
            }
            .infoBox{
                margin-top: 0px;
            }
            &:hover .date{
                .yearNum{
                    background: #333333;
                }
                .dateNum{
                    background: #fff;
                    color: #333;
                    border-right: 1px solid #333;
                    border-left: 1px solid #333;
                    border-bottom: 1px solid #333;
                }
            }
        }
    }

}
</style>